import React, { useState, useEffect } from 'react';
import AdminNavbar from "../Navbars/AdminNavbar";
import Sidebar from "../Sidebar/Sidebar";
import { AxiosResponse } from 'axios';
import { UserApis } from '../../apis/userApi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { convertUTCDateToLocalDate } from '../Reusable/functions';
import { NavLink } from 'react-router-dom';
import CostBreakdownEditor, { CostItem, emptyCostItem, costItemsTotal } from './CostBreakdownEditor';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';
import { SuperAdminApis } from '../../apis/superAdminApi';
import { STATUSTYPES } from '../Reusable/Status';
import { CURRENCYCODE } from '../Reusable/CurrencyCode';
import { COUNTRYCODE } from '../Reusable/CountryCode';
import AdminSidebar from '../Sidebar/AdminSidebar';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import VoucherFilterBar, {
  VoucherFilters,
  emptyVoucherFilters,
  voucherFiltersFromParams,
  voucherFiltersToParams,
  VOUCHER_FILTER_STORAGE_KEY,
} from './VoucherFilterBar';
import { FaPen } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import AccountList from './expenseCategory.json'



function ExpenseVoucher() {
  let [showScreen, setShowScreen] = React.useState<any>(1);

  const navigate = useNavigate();

  const userLoginData = useSelector((state: any) => state.data.login.value);

  let [shipmentData, setShipmentData] = React.useState<any>({
    full_name: "", department: "", email: '', description_of_purpose: '',
    category_of_expenses: '', justification_of_request: '', amount_requested: '',
    cost_breakdown: '', hod_email: '', audit_email: '', group_head_email: '',
    finance_email: '', general_manager_email: ''
  });

  // Itemised expenses. Starts with one blank row so there is somewhere to type.
  const [costItems, setCostItems] = React.useState<CostItem[]>([emptyCostItem()]);


  function refreshPage() {
    window.location.reload();
  }


  const [shipmentInfo, setShipmentInfo] = React.useState<any>([]);

  let [statusModal, setStatusModal] = React.useState<boolean>(false);


  let [hodStatusModal, setHodStatusModal] = React.useState<boolean>(false);
  let [gmStatusModal, setGmStatusModal] = React.useState<boolean>(false);
  let [auditStatusModal, setAuditStatusModal] = React.useState<boolean>(false);
  let [groupheadStatusModal, setGroupheadStatusModal] = React.useState<boolean>(false);
  let [financeStatusModal, setFinanceStatusModal] = React.useState<boolean>(false);
  let [deleteModal, setDeleteModal] = React.useState<boolean>(false);

  // Filters live in the URL rather than in component state. That is what makes them
  // survive the trip to the edit page and back — the Go Back button returns to the
  // exact address the list was on — and it makes a filtered list shareable.
  const [searchParams, setSearchParams] = useSearchParams();

  const filters: VoucherFilters = React.useMemo(
    () => voucherFiltersFromParams(searchParams),
    [searchParams],
  );

  // Restore the last filter set when the page is opened without one — someone coming
  // back through the sidebar, not through the Go Back button, still lands where they
  // left off. Runs once, and only when the URL is genuinely empty, so it can never
  // fight a link the user actually clicked.
  //
  // Decided before the first render so the fetch below can hold off for one tick
  // rather than loading the unfiltered list and then immediately replacing it.
  const pendingRestore = React.useRef<string | null>(null);
  const [restored, setRestored] = React.useState(false);

  if (!restored && pendingRestore.current === null) {
    try {
      pendingRestore.current = searchParams.toString()
        ? ''
        : (sessionStorage.getItem(VOUCHER_FILTER_STORAGE_KEY) || '');
    } catch {
      // Private browsing, or storage disabled — an unfiltered list is a fine default.
      pendingRestore.current = '';
    }
  }

  React.useEffect(() => {
    if (restored) return;

    if (pendingRestore.current) {
      setSearchParams(new URLSearchParams(pendingRestore.current), { replace: true });
    }

    setRestored(true);
  }, [restored, setSearchParams]);


  const [managers, setManagers] = React.useState<any>([]);

  React.useEffect(() => {
    const query: any = {
      search: '',
    };
    SuperAdminApis.getAllGms('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setManagers(response?.data?.data)
        }
      }
    ).catch(function (error) {
      // handle error

    })
  }, []);

  // The configured approval route, shown read-only on the create form.
  const [chainLevels, setChainLevels] = React.useState<any[]>([]);

  // Who on the first level should hold this voucher. A level like HOD has one person
  // per department and the creator knows which is theirs, so the choice routes the
  // voucher rather than notifying everyone on the level.
  const [firstLevelApprover, setFirstLevelApprover] = React.useState<string>('');

  // Only the first ACTIVE level offers a choice — that ordering has to match the
  // backend's, or the form would offer approvers for a level the voucher never
  // reaches. Later levels are not the creator's to pick.
  const firstLevel = React.useMemo(
    () => chainLevels.filter((l: any) => l.is_active).sort((a: any, b: any) => a.position - b.position)[0] ?? null,
    [chainLevels],
  );

  const firstLevelApprovers: any[] = React.useMemo(
    () => firstLevel?.approvers ?? [],
    [firstLevel],
  );

  // A single approver is not a choice — select it silently so the creator is not asked
  // a question with one answer.
  React.useEffect(() => {
    if (firstLevelApprovers.length === 1) setFirstLevelApprover(firstLevelApprovers[0].email);
  }, [firstLevelApprovers]);

  React.useEffect(() => {
    SuperAdminApis.getVoucherLevels()
      .then((response: any) => {
        if (response?.data?.status) {
          setChainLevels((response.data.data || []).filter((l: any) => l.is_active));
        }
      })
      .catch(() => {
        // Preview only — voucher creation still works without it.
      });
  }, []);


  const [img1, setImg1] = React.useState('No selected file');
  const [img12, setImg12] = React.useState('empty');

  function uploadImg1(e: any) {
    let size = (e.target.files[0].size / 1048576.0)
    if (e.target.files && e.target.files[0]) {
      if (size > 4) {
        if (e.target.name == 'uploadImg1') {
          e.target.value = ''
          toast.warn('Image too large')
        }
      }
      if (size <= 4) {
        if (e.target.name == 'uploadImg1') {
          setImg1(e.target.files[0]);
          setImg12(URL.createObjectURL(e.target.files[0]))
        }
      }
    }
  };



  let [approveModal, setApproveModal] = React.useState<boolean>(false);
  let [data, setData] = React.useState<any>([]);
  let [riderModal, setRiderModal] = React.useState<boolean>(false);
  let [loader, setLoader] = React.useState<boolean>(false);

  let [shipmentId, setShipmentId] = React.useState<any>([]);
  let [shipmentStatus, setShipmentStatus] = React.useState<any>('');

  let [creditCustomers, setCreditCustomers] = React.useState<any>([]);
  let [vehicle, setVehicle] = React.useState<any>([]);


  function toggleFinanceStatus(data: any) {
    setData(data)
    setFinanceStatusModal(true)
  }

  function toggleHodStatus(data: any) {
    setData(data)
    setHodStatusModal(true)
  }

  function toggleAuditStatus(data: any) {
    setData(data)
    setAuditStatusModal(true)
  }

  function toggleGmStatus(data: any) {
    setData(data)
    setGmStatusModal(true)
  }

  function toggleGroupheadStatus(data: any) {
    setData(data)
    setGroupheadStatusModal(true)
  }

  const deleteVoucher = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.deleteVoucher(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setDeleteModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);

          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [deleteModal]);



  const updateToReview = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    SuperAdminApis.updateToReview(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setStatusModal(false)
            SuperAdminApis.getAllCreditCustomers('', '').then(
              (response: any) => {
                if (response?.data) {
                  setCreditCustomers(response?.data?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, data, creditCustomers]);


  const approveByHod = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    console?.log(data?.id)
    SuperAdminApis.approveByHod(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.message);
            setHodStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false)
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, hodStatusModal, data, creditCustomers, loader]);



  const rejectByHod = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByHod(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setHodStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false);
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, loader, hodStatusModal, data, creditCustomers]);



  const approveByGrouphead = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.approveBygrouphead(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setGroupheadStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false)
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, groupheadStatusModal, data, creditCustomers, loader]);



  const rejectByGrouphead = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByGrouphead(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setHodStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false);
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, loader, groupheadStatusModal, data, creditCustomers]);

  const approveByAudit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.approveByAudit(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setAuditStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false)
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, groupheadStatusModal, data, creditCustomers, loader]);

  const approveByGm = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.approveByGm(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setGmStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false)
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, gmStatusModal, data, creditCustomers, loader]);

  const rejectByGm = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByGm(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setGmStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false);
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, loader, gmStatusModal, data, creditCustomers]);


  const rejectByAudit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByAudit(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setAuditStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false);
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, loader, auditStatusModal, data, creditCustomers]);


  const disburseByFinance = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.disburseByFinance(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setFinanceStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getAllExpenseVoucher().then(
              (response: any) => {
                if (response?.data) {
                  setLoader(false)
                  setCreditCustomers(response?.data?.data)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [shipmentInfo, financeStatusModal, data, creditCustomers, loader]);


  const handleShipmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShipmentData({ ...shipmentData, [e.target.name]: e.target.value });
  }


  // One fetch, driven by the URL. Every path that changes what should be on screen —
  // applying a filter, removing a chip, paging, the browser Back button — goes through
  // the address bar, so there is a single place the list can get out of step.
  React.useEffect(() => {
    // Wait for the saved filter to land in the URL, or the first paint would fetch the
    // unfiltered list and the restored one back to back.
    if (!restored) return;

    setLoader(true);

    SuperAdminApis.getAllExpenseVoucher({
      page: searchParams.get('page') || '',
      search: filters.search,
      email: filters.email,
      start_date: filters.start_date,
      end_date: filters.end_date,
      level_id: filters.level_id,
      approver_email: filters.approver_email,
      workflow_status: filters.workflow_status,
      mine: filters.mine ? 1 : '',
    })
      .then((response: AxiosResponse<any>) => {
        if (response?.data) setCreditCustomers(response?.data?.data);
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
        toast.error('Could not load vouchers');
      });
  }, [searchParams, filters, restored]);

  // Applying a filter always returns to page 1: page 4 of the old result set is rarely
  // page 4 of the new one, and an empty page reads as "no vouchers".
  const applyFilters = React.useCallback((next: VoucherFilters) => {
    const params = voucherFiltersToParams(next);

    try {
      sessionStorage.setItem(VOUCHER_FILTER_STORAGE_KEY, params.toString());
    } catch {
      // Storage unavailable — the URL still carries the filter for this visit.
    }

    setSearchParams(params);
  }, [setSearchParams]);

  const paginator = React.useCallback(
    (value: any) => {
      const params = voucherFiltersToParams(filters, value ?? '');

      try {
        sessionStorage.setItem(VOUCHER_FILTER_STORAGE_KEY, params.toString());
      } catch {
        // As above.
      }

      setSearchParams(params);
    }, [filters, setSearchParams]);


  const allOptions = AccountList.map((account: any) => ({
    value: account['Full name'],
    label: account['Full name'],
  }));

  const handleSearchChange = (selectedOption: any) => {
    setShipmentData({ ...shipmentData, 'category_of_expenses': selectedOption?.value });
    // setSearchText(selectedOption ? selectedOption?.value : '');
  };


  const schedule = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // The breakdown used to be a `required` textarea; the itemised editor is a set of
    // inputs the browser cannot validate as a group, so the rule moves here. A voucher
    // with no expenses on it is not a voucher.
    const filledItems = costItems.filter((item) => item.name.trim() !== '' && item.amount !== '');

    if (filledItems.length === 0) {
      toast.warn('Add at least one expense with a name and an amount');
      return;
    }

    if (costItemsTotal(filledItems) <= 0) {
      toast.warn('The expenses must total more than zero');
      return;
    }

    // Required whenever the first level actually has approvers to choose between.
    if (firstLevelApprovers.length > 0 && !firstLevelApprover) {
      toast.warn(`Choose who should approve this voucher at the ${firstLevel?.name} level`);
      return;
    }

    setLoader(true)
    const formData = new FormData()
    formData.append('full_name', userLoginData?.data?.first_name)
    formData.append('department', userLoginData?.data?.role)
    formData.append('email', userLoginData?.data?.email)
    formData.append('description_of_purpose', shipmentData?.description_of_purpose)
    formData.append('category_of_expenses', shipmentData?.category_of_expenses)
    formData.append('justification_of_request', shipmentData?.justification_of_request)
    formData.append('amount_requested', shipmentData?.amount_requested)
    // Posted as JSON because this form is multipart (it carries the supporting
    // document), so a nested array cannot survive the trip. The backend derives the
    // readable cost_breakdown text from these.
    formData.append('cost_items', JSON.stringify(
      costItems.filter((item) => item.name.trim() !== '' || item.amount !== '')
    ))
    formData.append('first_level_approver', firstLevelApprover)
    formData.append('supporting_document', img1)
    // Approvers come from the configured chain — the creator no longer names them.
    formData.append('hod_email', '')
    formData.append('audit_email', '')
    formData.append('general_manager_email', '')
    formData.append('group_head_email', '')
    formData.append('finance_email', '')
    SuperAdminApis.createExpenseVoucher(formData)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setShowScreen(1)
            setLoader(false)
            refreshPage()
          }
        } else {
          setLoader(false)
          toast.error('something went wrong');
        }

      }).catch((err: any) => {
        console.log(err);
        setLoader(false)
        toast.error('something went wrong');
      })

  }, [shipmentData, showScreen, loader, userLoginData, img1, costItems, firstLevelApprover, firstLevelApprovers, firstLevel]);

  return (
    <>
      <AdminSidebar title="Expense Voucher" />
      <div className="relative md:ml-64 bg-[#FAFAFA] ">
        <AdminNavbar title="Expense Voucher" />

        <div className={showScreen === 1 ? "block " : "hidden"}>
          <div className=' lg:px-10 pb-6 px-6 pt-5 bg-[#FAFAFA] min-h-screen'>

            <div className='flex justify-end mt-5'>
              <button
                onClick={() => setShowScreen(2)}
                type='button'
                className='bg-[#E04343] rounded-[32px] py-[6px] px-[25px] text-white font-medium'
              >
                + Create
              </button>
            </div>

            <VoucherFilterBar
              value={filters}
              levels={chainLevels}
              loading={loader}
              onApply={applyFilters}
            />

            <div className="relative overflow-x-auto">

              {
                loader ?
                  <div className='flex justify-center my-3 mt-20 pb-10'>
                    <Oval
                      visible={true}
                      height="80"
                      width="80"
                      color="#E04343"
                      secondaryColor="#FF3B300D"
                      ariaLabel="oval-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                  :
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                    <thead className="text-[12px] text-[#808080] bg-[#FAFAFA] ">
                      <tr>

                        <th scope="col" className="px-2 py-2">
                          S/N
                        </th>
                        {/* <th scope="col" className="px-2 py-2">
                    Run&nbsp;ID
                  </th> */}
                        <th scope="col" className="px-2 py-2">
                          Full&nbsp;Name
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Email&nbsp;Address
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Department
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Narration
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Amount&nbsp;Requested
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Amount&nbsp;Approved
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Date&nbsp;Created
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Voucher&nbsp;Id
                        </th>

                        {/* Where the voucher actually is, from the configurable chain */}
                        <th scope="col" className="px-2 py-2">
                          Stage
                        </th>

                        {/* One column showing each voucher's own chain. Fixed per-role
                            columns cannot work now that levels are configurable —
                            they showed "Not applicable" for every level the old
                            hard-coded set happened not to match. */}
                        <th scope="col" className="px-2 py-2 ">
                          Approvals
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Action
                        </th>



                      </tr>
                    </thead>


                    <tbody className=''>

                      {
                        creditCustomers?.data?.map(
                          (datas: any, index: any) => (
                            <tr className="bg-white  ">

                              <td className="px-4 py-2">
                                {index + 1}
                              </td>

                              <td className="px-4 py-4">
                                {datas?.full_name}
                              </td>

                              <td className="px-4 py-4 ">
                                {datas?.email}
                              </td>
                              <td className="px-4 py-4">
                                {datas?.department}
                              </td>

                              <td className="px-4 py-4">
                                {datas?.description_of_purpose}
                              </td>

                              <td className="px-4 py-4">
                                {datas?.amount_requested}
                              </td>
                              <td className="px-4 py-4">
                                {datas?.approved_amount ? datas?.approved_amount : '0'}
                              </td>

                              <td className="px-4 py-4">
                                {convertUTCDateToLocalDate(datas?.created_at)}
                              </td>

                              <td className="px-4 py-4">
                                {datas?.voucher_id}
                              </td>

                              {/* Stage — from the configurable approval chain.
                                  Fixed-width, single-line chip: long labels used to wrap
                                  inside a rounded-full pill and render as a blob. */}
                              <td className="px-4 py-4 align-top">
                                {datas?.workflow_status ? (() => {
                                  const done = datas.approved_levels ?? 0;
                                  const total = datas.total_levels ?? 0;
                                  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

                                  const state = datas.workflow_status === 'returned'
                                    ? { label: 'Returned', title: 'Rejected — sent back to the creator for changes', dot: 'bg-red-500', text: 'text-red-700', bg: 'bg-red-50 border-red-200', bar: 'bg-red-500' }
                                    : datas.workflow_status === 'disbursed'
                                      ? { label: 'Disbursed', title: 'Fully approved and paid out', dot: 'bg-green-600', text: 'text-green-700', bg: 'bg-green-50 border-green-200', bar: 'bg-green-600' }
                                      : datas.workflow_status === 'approved'
                                        ? { label: 'Approved', title: 'Completed the approval chain', dot: 'bg-green-600', text: 'text-green-700', bg: 'bg-green-50 border-green-200', bar: 'bg-green-600' }
                                        : { label: datas.current_level_name || 'In progress', title: `Awaiting approval at ${datas.current_level_name || 'the next level'}`, dot: 'bg-blue-500', text: 'text-blue-700', bg: 'bg-blue-50 border-blue-200', bar: 'bg-blue-500' };

                                  return (
                                    <div className='w-[112px]' title={state.title}>
                                      <span className={`inline-flex items-center gap-1.5 max-w-full px-2 py-[3px] rounded-md border text-[11px] font-[600] whitespace-nowrap ${state.bg} ${state.text}`}>
                                        <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${state.dot}`} />
                                        <span className='truncate'>{state.label}</span>
                                      </span>

                                      <div className='flex items-center gap-1.5 mt-1.5'>
                                        <div className='h-1 flex-1 bg-gray-200 rounded-full overflow-hidden'>
                                          <div className={`h-full rounded-full ${state.bar}`} style={{ width: `${pct}%` }} />
                                        </div>
                                        <span className='text-[10px] text-[#909090] tabular-nums shrink-0'>{done}/{total}</span>
                                      </div>
                                    </div>
                                  );
                                })() : (
                                  <span className='text-[10px] text-[#B0B0B0] italic'>legacy</span>
                                )}
                              </td>

                              {/* Approvals — this voucher's own chain */}
                              <td className="px-4 py-4 align-top">
                                {datas?.levels?.length ? (
                                  <div className='flex flex-col gap-1 min-w-[150px]'>
                                    {datas.levels.map((lvl: any) => (
                                      <div key={lvl.position} className='flex items-center justify-between gap-2'>
                                        <span className={`text-[11px] truncate ${lvl.is_current ? 'font-[700] text-[#19213D]' : 'text-[#4B5563]'}`}>
                                          {lvl.position}. {lvl.name}
                                        </span>
                                        <span className={`text-[10px] font-[600] px-1.5 py-[1px] rounded shrink-0 ${lvl.status === 'approved'
                                          ? 'bg-green-100 text-green-700'
                                          : lvl.status === 'rejected'
                                            ? 'bg-red-100 text-red-700'
                                            : lvl.is_current
                                              ? 'bg-blue-100 text-blue-700'
                                              : 'bg-gray-100 text-gray-500'}`}>
                                          {lvl.status === 'pending' && lvl.is_current ? 'awaiting' : lvl.status}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  /* Legacy vouchers keep the old fixed-role display */
                                  <div className='flex flex-col gap-1 min-w-[150px] text-[10px]'>
                                    {[
                                      ['HOD', datas?.hod_email, datas?.hod_approval_status],
                                      ['General Manager', datas?.general_manager_email, datas?.general_manager_approval_status],
                                      ['Audit', datas?.audit_email, datas?.audit_approval_status],
                                      ['Group Head', datas?.group_head_email, datas?.group_head_approval_status],
                                      ['Finance', datas?.finance_email, datas?.finance_approval_status],
                                    ].filter(([, email]) => !!email).map(([label, email, status]: any) => (
                                      <div key={label} className='flex items-center justify-between gap-2'>
                                        <span className='truncate text-[#4B5563]' title={email}>{label}</span>
                                        <span className={`text-[10px] font-[600] px-1.5 py-[1px] rounded shrink-0 ${status === 'approved' || status === 'completed'
                                          ? 'bg-green-100 text-green-700'
                                          : status === 'rejected'
                                            ? 'bg-red-100 text-red-700'
                                            : 'bg-amber-100 text-amber-700'}`}>
                                          {status}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </td>

                              <td className="px-4 py-4 cursor-pointer flex justify-between gap-5">
                                <NavLink to={`/admin/view-expense-voucher/${datas?.id}`}>
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="24" height="24" rx="4" fill="#EBEBEB" />
                                    <path d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z" fill="#3F83F8" />
                                    <path d="M15.2536 9.30891C14.2289 8.60625 13.1323 8.25 11.9944 8.25C10.9704 8.25 9.97219 8.55469 9.02742 9.15187C8.07469 9.75539 7.1407 10.8516 6.375 12C6.99422 13.0312 7.84125 14.0916 8.72344 14.6995C9.73547 15.3966 10.8359 15.75 11.9944 15.75C13.1428 15.75 14.2409 15.3968 15.2592 14.7002C16.1557 14.0859 17.0088 13.027 17.625 12C17.0067 10.9821 16.1508 9.92437 15.2536 9.30891ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.2493 12.5965 14.012 13.1684 13.5902 13.5902C13.1684 14.012 12.5965 14.2493 12 14.25Z" fill="#3F83F8" />
                                  </svg>
                                </NavLink>

                                {/* Vouchers on the configurable chain: the backend says
                                    whether this user holds the level it is sitting on.
                                    Review opens the detail page, where approve/reject
                                    and the full timeline live. */}
                                {datas?.can_act && (
                                  <NavLink
                                    to={`/admin/view-expense-voucher/${datas?.id}`}
                                    className="text-[11px] font-[600] bg-[#E04343] text-white px-2.5 py-1 rounded-md whitespace-nowrap hover:bg-[#c93a3a]"
                                    title={`Awaiting your approval at ${datas?.current_level_name}`}
                                  >
                                    Approve / Reject
                                  </NavLink>
                                )}

                                {datas?.awaiting_my_changes && (
                                  <NavLink
                                    to={`/admin/view-expense-voucher/${datas?.id}`}
                                    className="text-[11px] font-[600] bg-[#19213D] text-white px-2.5 py-1 rounded-md whitespace-nowrap hover:bg-[#2A3352]"
                                    title="Rejected — update it and resubmit"
                                  >
                                    Fix &amp; Resubmit
                                  </NavLink>
                                )}

                                {/* Legacy vouchers raised before the chain existed still
                                    use the old per-role buttons. */}
                                {!datas?.workflow_status && (
                                  <>
                                    {(userLoginData?.email == datas?.hod_email && datas?.hod_approval_status !== 'approved') ?
                                      <div onClick={() => toggleHodStatus(datas)} className="mt-1 cursor-pointer">
                                        <FaPen />
                                      </div>
                                      :
                                      ''
                                    }

                                    {(userLoginData?.data?.role == 'general manager' || userLoginData?.email == datas?.general_manager_email) && datas?.general_manager_approval_status !== 'approved' ?
                                      <div onClick={() => toggleGmStatus(datas)} className="mt-1 cursor-pointer">
                                        <FaPen />
                                      </div>
                                      :
                                      ''
                                    }

                                    {(datas?.audit_approval_status !== 'approved' && userLoginData?.data?.role == 'audit') ?
                                      <div onClick={() => toggleAuditStatus(datas)} className="mt-1 cursor-pointer">
                                        <FaPen />
                                      </div>
                                      :
                                      ''
                                    }

                                    {datas?.audit_approval_status == 'approved' && datas?.group_head_approval_status !== 'approved' && userLoginData?.data?.role == 'group head' ?
                                      <div onClick={() => toggleGroupheadStatus(datas)} className="mt-1 cursor-pointer">
                                        <FaPen />
                                      </div>
                                      :
                                      ''
                                    }

                                    {(datas?.group_head_approval_status == 'approved' && userLoginData?.data?.role == 'finance' && datas?.finance_approval_status !== 'approved') ?
                                      <div onClick={() => toggleFinanceStatus(datas)} className="mt-1 cursor-pointer">
                                        <FaPen />
                                      </div>
                                      :
                                      ''
                                    }
                                  </>
                                )}

                              </td>

                              <td className='pb-4 pr-2'>
                                {(userLoginData?.data?.role == 'admin' && datas?.finance_approval_status !== 'completed') ?
                                  <div onClick={() => { setDeleteModal(true); setData((datas)) }} className=" cursor-pointer">
                                    <MdDelete style={{ color: 'red' }} />
                                  </div>
                                  :
                                  ''
                                }
                              </td>

                              <td className='pb-4 pr-2'>
                                {(userLoginData?.data?.role !== 'admin' && datas?.hod_approval_status !== 'approved' && datas?.finance_approval_status !== 'completed') ?
                                  <div onClick={() => { setDeleteModal(true); setData((datas)) }} className=" cursor-pointer">
                                    <MdDelete style={{ color: 'red' }} />
                                  </div>
                                  :
                                  ''
                                }
                              </td>

                            </tr>
                          )
                        )

                      }

                    </tbody>

                  </table>
              }

            </div>

            <div className='m-4 flex justify-end mt-20'>
              {
                creditCustomers?.links?.filter(((item: any, idx: any) => idx < 1000)).map(
                  (datas: any, index: any) => (
                    <button onClick={() => paginator(datas?.label == 'Next &raquo;' ? datas?.url?.charAt(datas?.url?.length - 1) : (datas?.label === '&laquo; Previous') ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)} disabled={datas?.active} className={'mx-1 py-1 px-2 ' + ((datas?.active == false || datas?.url == null) ? 'bg-gray-300 text-black ' : 'bg-[#E04343] text-white')}>
                      {datas?.label == '&laquo; Previous' ? '< Previous' : (datas?.label === 'Next &raquo;') ? 'Next  >' : datas?.label}
                    </button>
                  )
                )
              }

            </div>

          </div>
        </div>
        <div>
          <form onSubmit={schedule}>
            <div className={showScreen === 2 ? "block " : "hidden"}>
              <div className=' lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
                {/* <!-- Sender Information --> */}
                <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">

                  <div>

                    <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto  mt-5">
                      <div className="relative flex flex-col min-w-0 break-words w-full  ">
                        <div className="flex-auto   py-10 pt-0">
                          <div className="flex flex-wrap ">

                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Full Name <span className=' text-red-600'>*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Company Name"
                                  name="full_name"
                                  defaultValue={userLoginData?.data?.first_name}
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>



                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Department <span className=' text-red-600'>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Company Phone Number"
                                  name="department"
                                  disabled
                                  defaultValue={userLoginData?.data?.role}
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>



                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  E-Mail Address <span className=' text-red-600'>*</span>
                                </label>
                                <input
                                  type="email"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Company Email"
                                  name="email"
                                  disabled
                                  defaultValue={userLoginData?.data?.email}
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>

                            <div className="w-full lg:w-8/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Narration (Include beneficiary bank details if applicable ) <span className=' text-red-600'>*</span>
                                </label>
                                <textarea
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Purpose"

                                  name="description_of_purpose"
                                  onChange={(e: any) => handleShipmentChange(e)}
                                  required
                                />
                              </div>
                            </div>


                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Category Of Expenses <span className=' text-red-600'>*</span>
                                </label>

                                <Select
                                  // className='w-[200px]'
                                  options={allOptions} // Options for the dropdown
                                  // defaultValue={allOptions[0]} // Set default selected value
                                  onChange={handleSearchChange} // Handle on change
                                  classNamePrefix="select" // Add custom class prefix if you need styling
                                  isSearchable // Make the dropdown searchable
                                  placeholder="Select a category"
                                  isClearable
                                  required
                                />
                                {/* <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder=""
                                  name="category_of_expenses"
                                  onChange={handleShipmentChange}
                                  required
                                /> */}
                              </div>
                            </div>


                            <div className="w-full lg:w-8/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Justification Of Request
                                </label>
                                <textarea
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Request justification"
                                  name="justification_of_request"
                                  onChange={(e: any) => handleShipmentChange(e)}

                                />
                              </div>
                            </div>

                            <div className=" w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Supporting Document
                                </label>
                                <input id="dropzone-file" onChange={uploadImg1} accept="image/x-png,image/gif,image/jpeg" name='uploadImg1' type="file" className={" mb-2 text-sm text-[#6C757D] font-medium"} />
                              </div>
                              <span className="text-[10px] text-[#dc143c]">File should not be more than 4MB.</span>
                            </div>


                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Amount Requested <span className=' text-red-600'>*</span>
                                </label>
                                <input
                                  type="number"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="NG"
                                  name="amount_requested"
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>


                            <div className="w-full lg:w-8/12 lg:pr-4">
                              <CostBreakdownEditor
                                items={costItems}
                                onChange={setCostItems}
                                amountRequested={shipmentData?.amount_requested}
                                required
                              />
                            </div>

                            {/* Approvers are no longer chosen by the creator — the chain
                                configured under Administration → Voucher Settings decides
                                the route. Shown read-only so they know where it goes. */}
                            <div className="w-full lg:w-12/12 lg:pr-4">
                              <div className="relative w-full bg-[#FAFAFA] border border-gray-200 rounded-[8px] p-4">
                                <p className="text-[12px] font-semibold text-[#19213D] mb-2">
                                  Approval route
                                </p>
                                {chainLevels.length === 0 ? (
                                  <p className="text-[12px] text-red-600">
                                    No approval chain has been configured yet — ask an administrator to set it up
                                    under Administration → Voucher Settings before raising vouchers.
                                  </p>
                                ) : (
                                  <>
                                    <div className="flex flex-wrap items-center gap-2">
                                      {chainLevels.map((level: any, i: number) => (
                                        <React.Fragment key={level.id}>
                                          <span className={`text-[11px] px-2.5 py-1 rounded-full border ${level.is_disbursement ? 'bg-green-50 border-green-200 text-green-800' : 'bg-white border-gray-300 text-[#333333]'}`}>
                                            {i + 1}. {level.name}{level.is_disbursement ? ' · disburses' : ''}
                                          </span>
                                          {i < chainLevels.length - 1 && <span className="text-[#B0B0B0]">→</span>}
                                        </React.Fragment>
                                      ))}
                                    </div>
                                    <p className="text-[11px] text-[#808080] mt-2">
                                      This voucher is routed automatically. Each level is notified in turn, and if one
                                      rejects it you will be emailed the reason so you can update and resubmit it.
                                    </p>

                                    {/* Only the first level is chosen by the creator. More than
                                        one approver means a real choice; exactly one is selected
                                        silently; none means the level is unconfigured and only an
                                        admin can move the voucher — worth saying out loud. */}
                                    {firstLevelApprovers.length > 1 && (
                                      <div className="mt-3 pt-3 border-t border-gray-200">
                                        <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                          Who should approve this at {firstLevel?.name}?
                                          <span className="text-red-600"> *</span>
                                        </label>
                                        <select
                                          value={firstLevelApprover}
                                          onChange={(e: any) => setFirstLevelApprover(e.target.value)}
                                          required
                                          className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2.5"
                                        >
                                          <option value="">Select an approver…</option>
                                          {firstLevelApprovers.map((a: any) => (
                                            <option key={a.email} value={a.email}>
                                              {a.name ? `${a.name} — ${a.email}` : a.email}
                                            </option>
                                          ))}
                                        </select>
                                        <p className="text-[11px] text-[#808080] mt-1">
                                          Only the person you choose will be notified and can approve at this level.
                                        </p>
                                      </div>
                                    )}

                                    {firstLevelApprovers.length === 1 && (
                                      <p className="text-[11px] text-[#808080] mt-2">
                                        {firstLevel?.name} goes to {firstLevelApprovers[0].name || firstLevelApprovers[0].email}.
                                      </p>
                                    )}

                                    {firstLevel && firstLevelApprovers.length === 0 && (
                                      <p className="text-[11px] text-red-600 mt-2">
                                        No approver is assigned to {firstLevel.name} — nobody but an administrator
                                        will be able to act on this voucher.
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>


                            {/* <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full">
                                <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                  General Manager Email <span className=' text-red-600'>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder=""
                                  name="general_manager_email"
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div> */}


                            {/* <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full">
                                <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                  Group Head Email <span className=' text-red-600'>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder=""
                                  name="group_head_email"
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div> */}



                            {/* <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full">
                                <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                  Finance Email <span className=' text-red-600'>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder=""
                                  name="finance_email"
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div> */}

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                {/* <!-- Receiver  Information --> */}


                <div className='flex justify-end mt-6'>

                  <button
                    // onClick={() => setShowScreen(2)}
                    type='submit'
                    disabled={loader}
                    className='bg-[#E04343] rounded-[10px] py-[5px] px-[20px] text-white inline-flex'>
                    <div className="flex justify-center gap-3 ">
                      <span> Create Voucher</span>
                      <Oval
                        visible={loader}
                        height="20"
                        width="20"
                        color="#E04343"
                        secondaryColor="#FCBF94"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                  </button>

                </div>



              </div>
            </div>

            {/* <!-- Shipments  Information --> */}

          </form>
        </div>

      </div>

      <section>
        <Modal
          visible={hodStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setHodStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can't be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 font-bold'>Voucher Approval by HOD</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setHodStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg">
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByHod(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByHod(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setHodStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={gmStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setGmStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can't be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by General Manager</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setGmStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={approveByGm}>
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByGm(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByGm(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setAuditStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>

      <section>
        <Modal
          visible={auditStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setAuditStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can't be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by Audit</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setAuditStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={approveByAudit}>
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByAudit(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByAudit(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setAuditStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>

      <section>
        <Modal
          visible={groupheadStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setGroupheadStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can't be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by Group Head</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setGroupheadStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={approveByGrouphead}>
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByGrouphead(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByGrouphead(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setHodStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={financeStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setFinanceStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can't be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by Finance</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setFinanceStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={disburseByFinance}>
                  <div className="flex justify-center gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => disburseByFinance(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Disburse
                    </button>




                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setHodStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={deleteModal}
          width="400"
          height="200"
          effect="fadeInUp"
          onClickAway={() => setDeleteModal(false)}
        >
          <div className="p-2" style={{ overflow: 'auto' }}>
            <span className="flex justify-between px-1 mb-3">
              <p className='font-bold mt-1'>Delete Expense Voucher</p>
              <p className="cursor-pointer font-bold" onClick={() => setDeleteModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>

            </span>

            <form onSubmit={deleteVoucher}>
              <div className='my-10 flex justify-center'>
                <span>Are you sure you want to delete this Voucher ?</span>
              </div>
              <div className="w-full flex justify-end">
                <button type='submit' className='bg-[#E04343] text-white py-[6px] rounded w-full'>Delete Voucher</button>
              </div>
            </form>
          </div>
        </Modal>
      </section>





      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </>
  )
}

export default ExpenseVoucher